import { AloftPrice } from '@aloft/toolkit-shared';

import { Td } from '../../../summary/components/Td.js';
import { Tr } from '../../../summary/components/Tr.js';
import { Typography } from '../../../summary/components/Typography.js';
import { COST_APPROACH_FIVE_COLUMN_WIDTHS } from '../constants.js';

export const CostApproachSummaryDepreciationRows = ({
  depreciation,
}: {
  depreciation:
    | {
        physical?: AloftPrice;
        functional?: AloftPrice;
        external?: AloftPrice;
        total?: AloftPrice;
      }
    | undefined;
}) => (
  <>
    <Tr>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[0]} isFirstColumn={true}>
        <Typography variant="body1">Less</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[1]} colSpan={2}>
        <Typography variant="body1">Physical</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[2]} colSpan={2}>
        <Typography variant="body1">Functional</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[3]} colSpan={2}>
        <Typography variant="body1">External</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[4]}></Td>
    </Tr>
    <Tr>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[0]} isFirstColumn={true}>
        <Typography variant="body1">Depreciation</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[1]} colSpan={2}>
        <Typography variant="body1">{depreciation?.physical?.toString(true) ?? ''}</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[2]} colSpan={2}>
        <Typography variant="body1">{depreciation?.functional?.toString(true) ?? ''}</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[3]} colSpan={2}>
        <Typography variant="body1">{depreciation?.external?.toString(true) ?? ''}</Typography>
      </Td>
      <Td width={COST_APPROACH_FIVE_COLUMN_WIDTHS[4]}>
        <Typography variant="body1" textAlign="right">
          {depreciation?.total ? `= (${depreciation.total.toString(true)})` : ''}
        </Typography>
      </Td>
    </Tr>
  </>
);
